import { useLazyQuery, useQuery } from "@apollo/client";
import { SHOPS } from "../shops.queries";
import {
  ShopsQuery,
  ShopsQueryVariables,
} from "../../../__generated__/ShopsQuery";

export const useShops = (variables: ShopsQueryVariables) => {
  return useQuery<ShopsQuery, ShopsQueryVariables>(SHOPS, {
    variables,
    fetchPolicy: "network-only",
  });
};

export const useLazyShops = () => {
  return useLazyQuery<ShopsQuery, ShopsQueryVariables>(SHOPS);
};
